





































import { Component, Mixins } from 'vue-property-decorator'
import { Getter } from 'vuex-class'

// Api
import userApi from '@/api/User'

// Mixins
import Form from '@/mixins/Form'
import Errors from '@/mixins/Errors'

// Components
import InputPassword from '@/components/common/InputPassword.vue'

@Component({
  components: {
    InputPassword
  }
})
export default class EditPasswordProfile extends Mixins(Form, Errors) {
  currentPassword: string = null
  newPassword: string = null
  newPasswordConfirm: string = null
  displayErrors: any
  formLoading: boolean = false
  $api: any

  @Getter('token') token

  async submitForm() {
    try {
      this.formLoading = true
      const res = await this.$validator.validateAll()
      const payload = { currentPassword: this.currentPassword, newPassword: this.newPassword }
      await this.$api.user.updatePassword(this.token, payload)
      this.$toast.open({
        message: this.$t('profile.edit_password.notification.success.content') as string,
        duration: 5000,
        type: 'is-success'
      })
    } catch (error) {
      this.displayErrors(error)
    } finally {
      this.formLoading = false
    }
  }
}
